// @core/api/endpoints/task/list_ready_tasks.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListTasksResponse,
} from '../../../types/task';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/task';

/**
 * List ready tasks
 * Returns tasks that have no unresolved blockers — all BLOCKED_BY dependencies point to tasks in DONE or CANCELLED status. Only includes tasks in OPEN or IN_PROGRESS status. Useful for agents and dashboards to find actionable work.
 */
export async function ListReadyTasks(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListTasksResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/tasks/ready`;
  const requestOptions = options;
  return client.get<ListTasksResponse>(requestPath, { ...requestOptions, params });
}
